import React from 'react'

export default function AddToSelection({ className }) {
  return (
    <svg viewBox="0 0 26 22" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M17.677 10.742c-.353-1.787-1.827-3.214-3.612-3.502a4.402 4.402 0 00-4.286 1.751.601.601 0 01-.985 0A4.402 4.402 0 004.508 7.24c-1.785.288-3.26 1.715-3.612 3.502a4.592 4.592 0 00.001 1.81c.894 4.746 8.364 9.419 8.364 9.419s7.521-4.673 8.415-9.419a4.573 4.573 0 00.001-1.81zM25 6h-3v3a1 1 0 01-2 0V6h-3a1 1 0 010-2h3V1a1 1 0 012 0v3h3a1 1 0 010 2z"
      />
    </svg>
  )
}
